export default __webpack_public_path__ + "static/media/equity.8484d5e0.png";